import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RelayPortManagementRoutingModule } from './relay-port-management-routing.module';
import { RelayPortManagementComponent } from './relay-port-management/relay-port-management.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { DataModule } from 'libs/portal/src/modules/keepalive/components/data/data.module';
import { CardTableModule } from 'libs/portal/src/modules/tools/card-table/card-table.module';
import { SearchableComboboxModule } from 'libs/portal/src/modules/tools/searchable-combobox/searchable-combobox.module';
import { ToolsModule } from 'libs/portal/src/modules/tools/tools.module';
import { RelayRoutingModule } from '../../relay-routing.module';

@NgModule({
  declarations: [RelayPortManagementComponent],
  imports: [
    CommonModule,
    RelayPortManagementRoutingModule,
    RelayRoutingModule,
    MaterialModule,
    DataModule,
    ToolsModule,
    CardTableModule,
    SearchableComboboxModule,
    NgApexchartsModule,
    CardTableModule,
    MaterialModule,
  ],
})
export class RelayPortManagementModule {}
